import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5a1c2ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "juou-card" }
const _hoisted_2 = { class: "qr" }
const _hoisted_3 = { class: "qr-time" }

import {
  JuouProTable,
  JuouProTableColumn,
  JuouProTableData,
  JuouProTableFilter,
  JuouProTableGetDataFunction,
  JuouDangerDialog,
  useBaseAsync,
  useRoute,
  useRouter,
  useBaseTenantStore,
} from 'juou-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import dayjs from 'dayjs';
import { getCurrentRootUrl, getCurrentUrl, todaySecToDayjs } from '@/utils';
import QrcodeVue from 'qrcode.vue';
import relate from './relate.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = ref<JuouProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof JuouProTable>>();
const relateRef = ref<InstanceType<typeof relate>>();
const baseTenantStore = useBaseTenantStore();
const addInitValue = {

};
const conditionsInitValue = {
};


const init = useBaseAsync(async() => {
  const res = await useApi().weappApi.listWeappweapp({
    conditions: {},
  });
  const options = res?.data?.data.map((item: any) => ({
    label: item.name,
    value: item.appid,
  })) || [];


  columns.value = [

    {
      name: 'remark',
      label: '备注',
      type: 'string',
      isCondition: true,
    },
    {
      name: 'name',
      label: '公众号名称',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
      hideEdit: true,
    },
    {
      name: 'appid',
      label: 'AppID',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
      hideEdit: true,
    },
    {
      name: 'principalName',
      label: '主体名称',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
      hideEdit: true,
    },
    {
      name: 'openMsgTemplateId',
      label: '开门模板消息(47550)id',
      type: 'string',
      width: 160,
    },
    {
      name: 'applyTemplateId',
      label: '门禁申请模板消息(58650)id',
      type: 'string',
      width: 160,
    },
    {
      name: 'weappAppid',
      label: '主小程序',
      type: 'select',
      options,
      hideCreate: true,
      hideEdit: true,

      width: 160,
    },
    {
      name: 'createTime',
      label: '授权时间',
      type: 'string',
      width: 80,
      hideCreate: true,
      hideEdit: true,
      render: ({ row: { createTime } }: any) => dayjs(createTime).format('YYYY-MM-DD HH:mm:ss'),
    },

  ];
});

const qrUrl = ref('');
const qrExpiresAt = ref('');
const visibleAuthQr = ref(false);
const qrloading = ref(false);

const topOperates: any[] = [
  {
    key: 'jumpAdd',
    name: '授权微信公众号',
    handler: async() => {
      visibleAuthQr.value = true;
      qrloading.value = true;
      try {
        const res = await useApi().wxApi.getWxAuthUrlwx({
          redirectUri: encodeURIComponent(`${getCurrentRootUrl()}${
            baseTenantStore.tenantInfo?.id ? `/___tenant_${baseTenantStore.tenantInfo?.id}` : ''
          }/auth?type=1`),
        });
        qrUrl.value = res.data.data?.url;
        qrExpiresAt.value = res.data.data?.expiresAt;
      } finally {
        qrloading.value = false;
      }
    },
  },
];

const currentRow = ref<any>();

const operates: any[] = [

  {
    key: 'relateWeapp',
    name: '关联小程序',
    handler: (row: any) => {
      console.log(row);
      currentRow.value = row;
      relateRef.value?.show(row.appid);
    },
  },
];

const loading = ref(false);


const getData = useBaseAsync<JuouProTableGetDataFunction>(async(filter: JuouProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().wxApi.pageWxwx({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }
        conditions[key] = val;
        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },


    });
    const tableData: JuouProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };

    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您正在进行删除(${row.name})操作，请谨慎操作`;


const updateFun = useBaseAsync(async(data: any) => {
  await useApi().wxApi.updateWxwx({
    wxAdminVo: data,
  });
  ElMessage.success('修改成功');
});
const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().wxApi.delWxwx(data.appid);
  ElMessage.success('删除成功');
});
const handleSetPrimary = useBaseAsync(async(_appid: string) => {
  await useApi().wxApi.updateWxwx({
    wxAdminVo: {
      ...currentRow.value,
      weappAppid: _appid,
    },
  });
  ElMessage.success('设置成功');
  tableRef.value?.refresh();
});


init();



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(JuouProTable), {
        ref_key: "tableRef",
        ref: tableRef,
        title: "微信公众号管理",
        paginations: { pageSize: 10 },
        columns: columns.value,
        "get-data": _unref(getData),
        "on-delete": _unref(deleteFun),
        "on-edit": _unref(updateFun),
        loading: loading.value,
        "is-dangder-delete": true,
        "format-dangder-delete-info": formatDeleteInfo,
        "row-key": "id",
        operates: operates,
        "top-operates": topOperates,
        "add-init-values": addInitValue,
        "codition-init-values": conditionsInitValue
      }, null, 8, ["columns", "get-data", "on-delete", "on-edit", "loading"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: visibleAuthQr.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visibleAuthQr).value = $event)),
      title: "公众号管理员扫码授权",
      width: 320
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(QrcodeVue, {
            value: qrUrl.value,
            size: 800,
            style: {"width":"200px","height":"200px"}
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_3, " 过期时间：" + _toDisplayString(qrExpiresAt.value), 1),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = () => { visibleAuthQr.value = false; tableRef.value?.refresh(); })
          }, {
            default: _withCtx(() => [
              _createTextVNode("已授权完成")
            ]),
            _: 1
          })
        ])), [
          [_directive_loading, qrloading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(relate, {
      onSetPrimary: _unref(handleSetPrimary),
      ref_key: "relateRef",
      ref: relateRef
    }, null, 8, ["onSetPrimary"])
  ], 64))
}
}

})